<template>
    <div>

    </div>
</template>
<script>
const { redirectSuccessPage } = require('../utils/authRoute.js')
export default {
    name: 'kong',
    data() {
        return {

        }
    },
    mounted() {
        let url = new URL(window.location.href);
        let parms = url.searchParams.get('response')
        let pageFlag = url.searchParams.get('pageFlag')
        console.log('parms:', parms);
        if (parms) {
            this.certifyId = JSON.parse(parms).extInfo.certifyId
            this.handleError(JSON.parse(parms).code, JSON.parse(parms).subCode, pageFlag)
        }
    },
    methods: {
        handleError(code, subCode, pageFlag) {
            if (code == 1000) {
                redirectSuccessPage(this.certifyId, pageFlag)
            } else if (code == 1001) {
                alert("表示系统错误。");
                //跳回登录
                this.$route.push('/pages/signIn/signIn')
            } else if (code == 1003) {
                 this.$route.push('/pages/signIn/signIn')
                switch (subCode) {
                    case 'Z5051':
                        alert("上传刷脸图片失败。");
                        break;
                    case 'Z5052':
                        alert("数据错误或程序异常。");
                        break;
                    case 'Z5053':
                        alert("网络错误。");
                        break;
                    case 'Z5054':
                        alert("摄像头无权限或无法获取摄像头数据。");
                        break;
                    case 'Z5055':
                        // alert("用户退出。");
                        break;
                    case 'Z5056':
                        alert("重试次数过多。");
                        break;
                    case 'Z5058':
                        alert("视频格式不满足要求。");
                        break;
                    case 'Z5059':
                        alert("视频中无有效人脸。");
                        break;
                    default:
                        alert("未知错误：" + subCode);
                }
            } else if (code == 2002) {
                
                alert("表示网络错误。");
                 this.$route.push('/pages/signIn/signIn')
            } else if (code == 2003) {
                alert("表示客户端设备时间错误。");
                 this.$route.push('/pages/signIn/signIn')
            } else if (code == 2006) {
                 this.$route.push('/pages/signIn/signIn')
                if (subCode === 'Z5128') {
                    alert("刷脸验证失败，认证未通过。可通过服务端查询接口获取认证未通过具体原因。");
                } else if (subCode === 'Z5052') {
                    alert("客户端提交认证数据到服务端处理结果异常，未进入认证流程。");
                } else {
                    alert("未知错误：" + subCode);
                }
            } else {
                alert("未知错误码：" + code);
                 this.$route.push('/pages/signIn/signIn')
            }
        },
    }
}
</script>
<style scoped></style>